import { Injectable } from '@angular/core';
import { Headers, RequestOptions, URLSearchParams, Http } from '@angular/http';

import 'rxjs/add/operator/toPromise';

@Injectable()
export class ExpenseTypeService {
    private headers = new Headers({
        'Content-Type': 'application/x-www-form-urlencoded; charset=UTF-8'
    });
    private expenseTypeUrl = 'api/expenseType';

    constructor(private http: Http) { }

    private extractData(res: any) {
        let body = res.json();
        return body || [];
    }

    getExpenseTypeList(query: any): Promise<any> {
        let params: URLSearchParams = new URLSearchParams();
        for (let key in query) {
            params.set(key.toString(), query[key]);
        }

        let options = new RequestOptions({
            headers: this.headers,
            search: params
        });

        return this.http
            .get(this.expenseTypeUrl + '/getExpenseTypeList', options)
            .toPromise()
            .then(this.extractData)
            .catch(this.handleError);
    }

    addUpdateExpenseType(data: any): Promise<any> {
        let params: URLSearchParams = new URLSearchParams();
        for (let key in data) {
            params.set(key.toString(), data[key]);
        }
        let body = params.toString();
        let options = new RequestOptions({ headers: this.headers });

        return this.http
            .post(this.expenseTypeUrl + '/addUpdateExpenseType', body, options)
            .toPromise()
            .then(this.extractData)
            .catch(this.handleError);
    }

    deleteExpenseType(data: any): Promise<any> {
        let params: URLSearchParams = new URLSearchParams();
        for (let key in data) {
            params.set(key.toString(), data[key]);
        }
        let body = params.toString();
        let options = new RequestOptions({ headers: this.headers });

        return this.http
            .post(this.expenseTypeUrl + '/deleteExpenseType', body, options)
            .toPromise()
            .then(this.extractData)
            .catch(this.handleError);
    }

    private handleError(error: any): Promise<any> {
        console.error('An error occurred', error);
        return Promise.reject(error.message || error);
    }
}



// WEBPACK FOOTER //
// /Applications/MAMP/htdocs/crm-soundsgood/src/app/services/expenseType.service.ts